module.exports = __webpack_public_path__ + "img/logon.44877e93.png";